// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CUG7","left":"styles_left__2GnsE"};